export default __webpack_public_path__ + "static/media/cross.1383112e.svg";